import { type LexicalEditor, $getRoot } from 'lexical'

export function clear(editor: LexicalEditor) {
    editor.update(() => {
        $getRoot().clear()
    })
}

export function getJson(editor: LexicalEditor) {
    return editor.getEditorState().toJSON()
}
